export { default } from './FirstPersons';
